import actions from "@/store/modules/users/qualifications/actions";
import {
  mutations,
  state
} from "@/store/modules/users/qualifications/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
